module.exports = {
	extends: [
		'/',
		'base',
		'tableSimple',
		'table'
	],

	config: {
		isSortable: true,
		lazyloadStepSize: 25,
		preventSortOfField: {},
		buttonContext: 'cooperation',
		showHead: false,
		showInsertButton: false,
		inline: true
	},

	methods: {
		onBuild: function(storage){
			if(storage.isClient){
				var controller = getComponent('artCrmController');
				if(controller && (controller.model || {}).cooperationTableShouldWaitForExternalFilters){
					this.model.waitForExternalFilters = true;
					controller.model.cooperationTableShouldWaitForExternalFilters = false;
				}
			}
		},

		loadResourcesGranted: function(storage, resourceFilters, actionKey, fieldCode, attachTriggerOptions){
			return true;
		},

		onResourceSanitized: function(){
			this.model.waitForExternalFilters = false
		},

		showInsert: function(){
			return getComponent('artCrmController').showInsert('cooperation');
		},

		showEdit: function(cooperationID, cooperationData){
			if(((this.model.controller || {}).config || {}).usage === 'selection'){
				return this.triggerClosest('onDecision', {
					decisionType: 'cooperationSelected',
					decisionComponent: this,
					cooperationID,
					cooperationData
				});
			}
			return getComponent('artCrmController').showEdit('cooperation', cooperationID, cooperationData);
		},

		addEntity: function(entity){
			if(this.config.isReady && this.model.$table){
				this.model.$table.append(this.include('./row', { config: this.config, resourceData: entity, model: this.model }))
			}
		},
	},

	hooks: {
		attach: function($element, options){
			var self = this;
			if(!self.model.controller){
				self.closest('templates_artCrm_entity_controller', function(controller){
					self.model.controller = controller
				});
			}

			self.model.$table = $element.find('table');
		}
	},

	handlers: [{
		name: 'recordControllerResourcesModified',
		handle: function(callerComponent) {
			if((
				callerComponent.config.entityContext === 'address' ||
				callerComponent.config.entityContext === 'cooperation'
			) && this.config.isReady){
				this.refreshData();
			}
		}
	}]
}